import React from 'react';
import {
  AlertTriangle,
  CheckCircle2,
  CircleOff,
  Loader2,
  Mic2,
  RotateCcw,
  UploadCloud,
  Wrench,
} from 'lucide-react';
import { Badge } from '../components/ui/badge';
import { getAdminAudioStatus } from './adminAudioStatus';
import { isAudioEnabledSubmission } from './adminAudioEligibility';

const STATUS_PRESENTATIONS = {
  missing: {
    className: 'border-slate-300 bg-slate-50 text-slate-700 dark:border-slate-700 dark:bg-slate-900/50 dark:text-slate-200',
    Icon: CircleOff,
  },
  needs_recording: {
    className: 'border-amber-300 bg-amber-50 text-amber-800 dark:border-amber-800 dark:bg-amber-950/40 dark:text-amber-100',
    Icon: Mic2,
  },
  received: {
    className: 'border-sky-300 bg-sky-50 text-sky-800 dark:border-sky-800 dark:bg-sky-950/40 dark:text-sky-100',
    Icon: UploadCloud,
  },
  processing: {
    className: 'border-cyan-300 bg-cyan-50 text-cyan-800 dark:border-cyan-800 dark:bg-cyan-950/40 dark:text-cyan-100',
    Icon: Loader2,
    animate: true,
  },
  editing: {
    className: 'border-violet-300 bg-violet-50 text-violet-800 dark:border-violet-800 dark:bg-violet-950/40 dark:text-violet-100',
    Icon: Wrench,
  },
  review: {
    className: 'border-indigo-300 bg-indigo-50 text-indigo-800 dark:border-indigo-800 dark:bg-indigo-950/40 dark:text-indigo-100',
    Icon: CheckCircle2,
  },
  ready: {
    className: 'border-emerald-300 bg-emerald-50 text-emerald-800 dark:border-emerald-800 dark:bg-emerald-950/40 dark:text-emerald-100',
    Icon: CheckCircle2,
  },
  retake: {
    className: 'border-amber-300 bg-amber-50 text-amber-800 dark:border-amber-800 dark:bg-amber-950/40 dark:text-amber-100',
    Icon: RotateCcw,
  },
  error: {
    className: 'border-red-300 bg-red-50 text-red-800 dark:border-red-800 dark:bg-red-950/40 dark:text-red-100',
    Icon: AlertTriangle,
  },
};

export function AdminAudioStatusBadge({ submission, className = '' }) {
  if (!isAudioEnabledSubmission(submission)) return null;

  const status = getAdminAudioStatus(submission);
  const presentation = STATUS_PRESENTATIONS[status.key];
  const Icon = presentation.Icon;

  return (
    <Badge
      variant="outline"
      className={`${presentation.className} gap-1 whitespace-nowrap ${className}`.trim()}
      data-audio-state={status.key}
    >
      <Icon className={`h-3 w-3 ${presentation.animate ? 'animate-spin' : ''}`} />
      {status.label}
    </Badge>
  );
}

export default AdminAudioStatusBadge;
